// Golf 8: نصوص التطبيق للتحقق اليومي ودائرة العائلة. هادئة؛ ليست إنذارًا أبدًا.
// POORT: moedertaalreview vóór livegang.
export const appCareAr = {
    nav: 'التحقق والدائرة',
    notForRelative: 'هذه الصفحة ليست متاحة للمتابعين.',
    account: 'الحساب',
    viaBoard: '(وافق على اللوحة)',
    viaApp: '(وافق في التطبيق)',
    subjectLabel: 'من ينقر كل يوم؟',
    removed: 'تمت إزالة {label} من الدائرة.',
    left: 'لقد غادرت الدائرة.',
    comingSoon: 'التحقق اليومي ودائرة العائلة قادمان قريبًا. اللوحة والتقويم والتذكيرات تعمل الآن.',
    wizardSeniorLine: 'هل ستتابع العائلة لاحقًا؟ يمكنك تشغيل ذلك من الإعدادات، التحقق والدائرة.',
    setupSaved: 'التحقق جاهز.',
    circleOn: 'السماح للعائلة بالمتابعة',
    personRights: 'صلاحيات {label}',
    managerSeesAll: 'يدير اللوحة ويرى كل شيء.',
    noReachSave: 'يمكن التشغيل فقط عندما يستطيع أحد تلقي تنبيه.',
    consentLaterWizard: 'لا يبدأ التحقق إلا عندما يقول {name} نعم على اللوحة.',
    title: 'التحقق والدائرة',
    settingsBody: 'زر كبير «كل شيء بخير» على اللوحة، وعائلة تتابع من بعيد.',
    widgetTitle: 'التحقق اليومي',
    setupTitle: 'هكذا تبقون على تواصل',
    setupIntro: 'كل يوم ينقر {name} مرة واحدة على «كل شيء بخير». إن لم يحدث ذلك تتلقى العائلة تنبيهًا هادئًا.',
    whoUsesBoard: 'من يستخدم اللوحة؟',
    boardSelf: 'أنا',
    boardOther: 'شخص آخر',
    otherName: 'ما اسم هذا الشخص؟',
    otherNamePlaceholder: 'مثلًا أمي',
    ownerHidden: 'أنت لا تظهر على اللوحة.',
    capacityQ: 'هل يستطيع {name} أن يقرر ذلك بنفسه؟',
    capacityYes: 'نعم',
    capacityNoButton: 'لا',
    capacityNo: 'إذن لا يمكننا تشغيل التحقق بعد. يجب أن يستطيع {name} قول نعم بنفسه. اللوحة والتقويم يعملان كالمعتاد.',
    checkInToggle: 'التحقق اليومي',
    deadline: 'في موعد أقصاه',
    days: 'في هذه الأيام',
    dayNames: ['الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت', 'الأحد'],
    grace: 'التنبيه بعد',
    graceMin: '{n} دقيقة',
    whoFollows: 'من يتابع؟',
    whoFollowsHint: 'يتلقى الجميع بريدًا إلكترونيًا. ثم يقول {name} على اللوحة إن كان موافقًا.',
    inviteEmail: 'البريد الإلكتروني',
    inviteLabel: 'بماذا يناديك {name}؟',
    inviteLabelOther: 'بماذا ينادي {name} هذا الشخص؟',
    addPerson: 'شخص آخر',
    rightAlerts: 'تنبيه إذا لم يصل «كل شيء بخير»',
    rightAgenda: 'رؤية التقويم (دون المواعيد الخاصة)',
    invite: 'دعوة',
    invited: 'أُرسلت الدعوة إلى {email}',
    later: 'لاحقًا',
    disclaimerTitle: 'ليست خدمة طوارئ',
    disclaimerBody: 'التحقق تنبيه هادئ وليس إنذارًا. لا يكتشف السقوط ولا يطلب المساعدة. عدم وصول رسالة لا يعني دائمًا أن كل شيء بخير. في حالة الطوارئ اتصل بالرقم 112.',
    disclaimerCheck: 'أفهم أن هذه ليست خدمة طوارئ.',
    selfConsentNow: 'لأنك تستخدم اللوحة بنفسك، نطلب موافقتك هنا.',
    otherConsentLater: 'في المرة الأولى تسأل اللوحة {name} إن كان موافقًا. حتى ذلك الحين لا يُرسل أي تنبيه.',
    finish: 'تم',
    save: 'حفظ',
    saved: 'تم الحفظ',
    cancel: 'إلغاء',
    enable: 'تشغيل',
    disable: 'إيقاف',
    reachTitle: 'من يتلقى تنبيهًا؟',
    reachOk: '{n} من {m} يتلقون تنبيهًا الآن.',
    reachNone: 'لا أحد يتلقى تنبيهًا الآن.',
    reachNeedsInstall: 'على {label} أولًا إضافة AMUMIN إلى الشاشة الرئيسية.',
    reachNoPush: 'لم يشغّل {label} الإشعارات بعد.',
    reachFailed: 'لم يصل التنبيه الأخير إلى {label}.',
    reachEnableFirst: 'شغّل الإشعارات على هاتفك أولًا. بعد ذلك يمكنك تشغيل التحقق.',
    noReachInvited: 'لا يمكن لأحد تلقي تنبيه بعد: على {names} قبول الدعوة أولًا. بعد ذلك يمكنك تشغيل التحقق.',
    noReachYourYes: 'لا يمكن لأحد تلقي تنبيه بعد: {names} ينتظر موافقتك (أعلى صفحة اليوم). بعد ذلك يمكنك تشغيل التحقق.',
    noReachTheirYes: 'لا يمكن لأحد تلقي تنبيه بعد: {names} ينتظر موافقة {name} على اللوحة.',
    noReachPush: 'لا يمكن لأحد تلقي تنبيه بعد: على {names} تشغيل الإشعارات أولًا. بعد ذلك يمكنك تشغيل التحقق.',
    noReachSelf: 'لا يمكن لأحد تلقي تنبيه بعد. ادعُ شخصًا للمتابعة؛ يقبل الدعوة ويشغّل الإشعارات.',
    pendingOnTitle: 'التحقق اليومي ما زال متوقفًا',
    pendingOnReady: 'يمكن الآن لشخص ما تلقي تنبيه ({n} من {m}). يمكنك تشغيل التحقق.',
    pendingOnButton: 'تشغيل التحقق',
    pendingOnDone: 'التحقق اليومي يعمل.',
    pushEnable: 'تشغيل الإشعارات على هذا الهاتف لبيت {name}',
    pushOpen: 'ضبط الإشعارات',
    iosInstall: 'على iPhone: انقر مشاركة، ثم «إضافة إلى الشاشة الرئيسية»، وافتح AMUMIN من هناك.',
    waitConsent: 'في انتظار موافقة {name} على اللوحة.',
    declined: 'يفضّل {name} عدم ذلك. يمكنك السؤال مجددًا بعد {date}.',
    askAgain: 'السؤال مجددًا على اللوحة',
    activeSince: 'مفعّل منذ {date}',
    stoppedGone: 'لم يعد {name} في هذا المنزل. التحقق متوقف.',
    stoppedBySelf: 'أوقف {name} التحقق اليومي. يمكنك أن تطلب ذلك مجددًا.',
    orphanTitle: 'لم تعد جزءًا من أي منزل',
    orphanBody: 'لم تعد تتابع أحدًا ولست عضوًا في أي منزل. يبقى حسابك حتى تحذفه بنفسك.',
    orphanAccount: 'الحساب',
    orphanLogout: 'تسجيل الخروج',
    stateDone: 'نقر {name} على «كل شيء بخير» الساعة {time}.',
    stateWaiting: 'ليس بعد. في موعد أقصاه {time}.',
    stateDue: 'ليس بعد. لا يزال بإمكان {name} النقر.',
    stateMissing: 'لم يصل «كل شيء بخير» من {name} اليوم بعد.',
    stateMissingEarlier: 'أمس ({date}) لم يصل «كل شيء بخير» من {name}.',
    stateBoardOffline: 'اللوحة غير متصلة منذ {time}، لذا قد لا يستطيع {name} النقر.',
    stateNoBoard: 'لا توجد لوحة مقترنة.',
    stateResolved: 'كل شيء بخير في النهاية: نقر {name} الساعة {time}.',
    stateResolvedOffline: 'كل شيء بخير في النهاية: نقر {name} الساعة {time} (كانت اللوحة غير متصلة).',
    stateResolvedManual: '{label}: كل شيء بخير ({time}).',
    stateNotChecked: 'لم نتمكن من التحقق اليوم (عطل لدى AMUMIN). اطمئن بنفسك من فضلك.',
    stateDegraded: 'لا نتحقق الآن (عطل).',
    statePaused: 'متوقف مؤقتًا حتى {date} (بواسطة {label}).',
    stateOff: 'التحقق متوقف.',
    stateNotToday: 'لا يوجد تحقق اليوم.',
    stateConsentNeeded: 'في انتظار موافقة {name} على اللوحة.',
    stateDeclined: 'يفضّل {name} عدم ذلك.',
    silenceNote: 'عدم وصول رسالة لا يعني دائمًا أن كل شيء بخير.',
    emergencyNote: 'ليست خدمة طوارئ. في الطوارئ: 112.',
    ack: 'سأتصل',
    acked: '{label} يتصل ({time})',
    ackStale: '{label} يتصل منذ {time}، لم يُؤكَّد بعد.',
    resolve: 'كل شيء بخير',
    tzNote: '(التوقيت عند {name})',
    history: 'آخر {n} يومًا',
    historyKinds: {
        done: 'كل شيء بخير',
        late: 'نقر لاحقًا',
        missing: 'لا نقر',
        paused: 'إيقاف مؤقت',
        not_checked: 'لم يُتحقق',
        off: 'لا تحقق',
    },
    pauses: 'فترات الإيقاف',
    pauseAdd: 'إضافة إيقاف مؤقت',
    pauseFrom: 'من',
    pauseTo: 'حتى (ضمنًا)',
    pauseMax: 'بحد أقصى {n} يومًا. غياب أطول؟ أوقف التحقق إذن.',
    inviteInUse: 'لهذا العنوان دعوة بالفعل كشريك سكن. اسحبها أولًا.',
    pauseLimit: 'يمكن للمتابع إيقاف مؤقت لمدة {n} يومًا كحد أقصى إجمالًا، وليس أبعد من {n} يومًا مقدمًا.',
    someone: 'شخص ما',
    pauseHint: 'مثلًا في عطلة أو زيارة. لا نحفظ أي سبب.',
    pauseLine: 'من {from} حتى {to} (بواسطة {label})',
    pauseStop: 'إنهاء الإيقاف',
    pauseNone: 'لا يوجد إيقاف مخطط.',
    offlineTitle: 'ماذا لو كانت اللوحة غير متصلة؟',
    offlineHelp: 'إن لم يكن للوحة اتصال، يُرسل النقر لاحقًا. يمكن لـ{name} أيضًا استخدام التطبيق على الهاتف.',
    outageTitle: 'ماذا لو حدث عطل لدى AMUMIN؟',
    outageHelp: 'عند حدوث عطل لدى AMUMIN سترى هنا «لم يُتحقق اليوم». عدم وصول رسالة ليس دليلًا على أن كل شيء بخير.',
    circleTitle: 'الدائرة',
    circleEmpty: 'لا أحد يتابع بعد.',
    circleStatusInvited: 'مدعو',
    circleStatusPending: 'في انتظار موافقة {name}',
    circleStatusActive: 'نشط',
    circleStatusDeclined: 'يفضّل عدم ذلك',
    roleRelative: 'متابع',
    roleManager: 'مدير',
    remove: 'إزالة من الدائرة',
    removeConfirm: 'إزالة {label} من الدائرة؟ لن يرى {label} أي شيء بعد ذلك فورًا.',
    removePauseNote: 'وضع {label} إيقافًا مؤقتًا حتى {date}. ينتهي هذا الإيقاف عند إزالة {label}.',
    leave: 'مغادرة الدائرة',
    leaveConfirm: 'مغادرة الدائرة؟ لن ترى بعد ذلك أي شيء من بيت {name}.',
    resend: 'إرسال مجددًا',
    rightsNeedYes: 'صلاحيات أكثر؟ عندها تطلب اللوحة أولًا موافقة {name}.',
    newWatcher: '{label} يتابع الآن: {rights}.',
    inviteSomeone: 'دعوة شخص',
    seniorNoCircle: 'لا يوجد بعد أحد يمكنه تلقي تنبيه.',
    switchToCare: 'يصبح «في البيت مع عائلة تتابع»',
    selfButton: 'كل شيء بخير',
    selfConsentIntro: 'اقرأ هذا بهدوء. أنت تقرر.',
    selfWithdraw: 'إيقاف التحقق',
    approveTitle: '{label} يرغب في المتابعة',
    approveYes: 'نعم، موافق',
    approveNo: 'أفضّل لا',
    myCircleTitle: 'دائرتي',
    myRights: 'ما تراه في بيت {name}',
    myRightsNone: 'لا ترى شيئًا بعد: يقول {name} نعم أولًا على اللوحة.',
    pushCheckIn: 'التحقق اليومي',
    pushCheckInQuiet: 'أيضًا خلال ساعات الهدوء (وإلا يصل التنبيه بعدها)',
    inviteTitle: 'دعوة للمتابعة',
    inviteBody: 'يدعوك {inviter} للمتابعة لدى {household} باسم «{label}».',
    inviteRights: 'يمكنك:',
    inviteAcceptExisting: 'قبول',
    inviteLoginFirst: 'سجّل الدخول أولًا بـ {email}، ثم افتح الرابط مجددًا.',
    inviteAcceptNew: 'إنشاء حساب وقبول',
    invitePassword: 'اختر كلمة مرور',
    inviteWrongEmail: 'هذه الدعوة لعنوان بريد إلكتروني آخر.',
    inviteInvalid: 'هذه الدعوة غير صالحة أو منتهية.',
    inviteAccepted: 'تم. تسأل اللوحة أولًا إن كان ذلك مقبولًا. بعد ذلك ستراه هنا.',
    inviteToApp: 'إلى التطبيق',
    notEmergencyShort: 'هذه ليست خدمة طوارئ.',
    errorGeneric: 'لم ينجح ذلك. حاول مرة أخرى.',
};
//# sourceMappingURL=careApp.ar.js.map